import config from '../config';

// Members who must verify their email are sent to the consumer web app's verify screen and brought
// back to the exact Leagues URL afterwards. UT_API signals this two ways: `emailVerificationRequired`
// on GET v1/auth/current, and -- once enforcement is on -- a 403 `account_not_verified` from gated
// routes. The 403 is not a sign-out: the session stays valid, so it must never bounce to login.
export const VERIFY_EMAIL_PATH = '/verify-email';
export const ACCOUNT_NOT_VERIFIED_CODE = 'account_not_verified';

// Strictly `=== true` so an absent flag (older API, or a member who does not need to verify) keeps
// today's behavior. This is the hard stop; the skippable prompt (`emailVerificationPrompt`) is handled by
// EmailVerificationPrompt, which always defers to this.
export const isEmailVerificationRequired = (user) => {
    return user?.emailVerificationRequired === true;
};

export const isAccountNotVerifiedError = (error) => {
    return error?.response?.status === 403 && error.response.data?.code === ACCOUNT_NOT_VERIFIED_CODE;
};

export const buildVerifyEmailUrl = () => {
    return `${config.nextAppHost}${VERIFY_EMAIL_PATH}?returnTo=${encodeURIComponent(window.location.href)}`;
};

// Several gated requests usually fail together on one page. Navigate once per page load so parallel
// 403s do not stack navigations (and do not overwrite the returnTo with a half-loaded URL).
let hasRedirectedToVerifyEmail = false;

export const redirectToVerifyEmail = () => {
    if (hasRedirectedToVerifyEmail) {
        return;
    }

    hasRedirectedToVerifyEmail = true;
    window.location.href = buildVerifyEmailUrl();
};

export const attachAccountNotVerifiedInterceptor = (instance) => {
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (isAccountNotVerifiedError(error)) {
                redirectToVerifyEmail();
            }

            // Always re-reject so callers keep their existing error handling.
            return Promise.reject(error);
        }
    );

    return instance;
};
